import { DefaultTheme } from 'styled-components'

const xpert: DefaultTheme = {
  colors: {
    common: {
      accentDark: '#3F82A5',
      accentLight: '#DEEAFC',
      accentMedium: '#50A3D0',
      alert: '#BF002F',
      alertLight: '#FCE6EB',
      background: '#F2F4F6',
      backgroundMedium: '#E0DCDB',
      black: '#222222',
      black05: 'rgba(34, 34, 34, 0.05)',
      black10: 'rgba(34, 34, 34, 0.10)',
      black20: 'rgba(34, 34, 34, 0.20)',
      black62: 'rgba(34, 34, 34, 0.62)',
      black75: 'rgba(34, 34, 34, 0.75)',
      black95: 'rgba(34, 34, 34, 0.95)',
      border: 'rgba(34, 34, 34, 0.20)',
      closeButtonBackground: '#f0f0f5',
      darkSeaGreen: '#05AB5F',
      darkSteelBlue: '#5775A8',
      endEvent: '#ffd5cc',
      error: '#f5d6e0',
      generalEvent: '#b7eee0',
      mediumSeaGreen: '#09B968',
      mediumSeaGreenLight: '#C3E5D4',
      periwinkleExtraLight: '#F1F6FE',
      selected: '#666a71',
      warning: '#FFAA00',
      warningLight: '#FFEBC4',
      white: '#ffffff',
    },
    disabled: {
      main: '#DBE0E6',
      text: '#FFFFFF',
    },
    primary: {
      active: '#73B6DA',
      hover: '#3F82A5',
      main: '#50A3D0',
      text: '#FFFFFF',
    },
    secondary: {
      active: 'rgba(34, 34, 34, 0.40)',
      border: 'rgba(34, 34, 34, 0.40)',
      hover: 'rgba(34, 34, 34, 0.10)',
      main: '#FFFFFF',
      text: '#222222',
    },
  },
  spacing: 8,
  zIndex: {
    modal: 100,
    notification: 200,
  },
}

const velthuis: DefaultTheme = {
  ...xpert,
  colors: {
    ...xpert.colors,
    common: {
      ...xpert.colors.common,
      accentDark: '#A24E98',
      accentLight: '#A24E98',
      accentMedium: '#A24E98',
    },
    primary: {
      active: '#B071A9',
      hover: '#954a8c',
      main: '#A24E98',
      text: '#FFFFFF',
    },
  },
}

export { velthuis, xpert }
